import { Group, ScrollArea, Stack } from '@mantine/core';
import { FilterPanelGroup } from '../../../components/filters/filter-panel-group';
import { FilterPanelHeader } from '../../../components/filters/filter-panel-header';
import { SmallSquareButton } from '../../../components/small-square-button/small-square-button';
import { useStrategyStore } from '../../../store/strategy-store/strategy-store';
import { resetFilters, toggleCollapsedGroup } from '../../../store/strategy-store/strategy-store.actions';
import { Divider } from '../../../ui-library/divider/divider';
import { Text } from '../../../ui-library/typography/typography';
import { useEpicFilterGroups } from './epics-filters.hooks';
import type { FilterGroup as BaseFilterGroup } from '../../../components/filters/filter-panel.type';

type FilterGroup = BaseFilterGroup & {
  id: string;
};

export interface EpicsFiltersProps {
  setShow: (show: boolean) => void;
  title?: string;
}

export const EpicsFilters = ({ setShow, title }: EpicsFiltersProps) => {
  const filterGroups = useEpicFilterGroups();
  const collapsedGroups = useStrategyStore((state) => state.collapsedGroups);

  const handleReset = () => {
    resetFilters();
  };

  const isGroupCollapsed = (groupId: string): boolean => {
    return collapsedGroups[groupId];
  };

  const isAllSelected = (group: FilterGroup): boolean => {
    return (
      (group.selectedValues || []).length > 0 && (group.selectedValues || []).length === (group.options || []).length
    );
  };

  const handleAllChange = (group: FilterGroup, isChecked: boolean): void => {
    group.onSelectionChange(isChecked ? group.options.map((opt) => opt.value) : []);
  };

  const handleIndividualChange = (group: FilterGroup, value: string, isChecked: boolean): void => {
    const newValues = isChecked ? [...group.selectedValues, value] : group.selectedValues.filter((v) => v !== value);

    group.onSelectionChange(newValues);
  };

  return (
    <Stack data-bf="strategy-filter-epics" gap="md" h="100%">
      <Group justify="space-between">
        <Text size="medium" weight="medium">
          {title || 'Epics'}
        </Text>
        <SmallSquareButton onClick={() => setShow(false)} iconName="arrow_back_ios" />
      </Group>
      <Divider />
      <FilterPanelHeader onResetFilters={handleReset} />
      <Divider />

      <ScrollArea h="100%" scrollbarSize={0} style={{ flex: 1 }}>
        <Stack gap="md">
          {filterGroups.map((group) => (
            <FilterPanelGroup
              key={group.id}
              group={group}
              toggleCollapsed={(group) => toggleCollapsedGroup(group.id)}
              isCollapsed={isGroupCollapsed(group.id)}
              isAllSelected={isAllSelected(group)}
              handleAllChange={handleAllChange}
              handleIndividualChange={handleIndividualChange}
              hasDivider={group !== filterGroups[filterGroups.length - 1]}
            />
          ))}
        </Stack>
      </ScrollArea>
    </Stack>
  );
};
